import { cn } from '../../utils/cn';

const Logo = ({ 
  variant = 'default',
  size = 'md',
  className,
  ...props 
}) => {
  const sizes = {
    sm: 'h-8 w-auto',
    md: 'h-12 w-auto',
    lg: 'h-16 w-auto',
    xl: 'h-20 w-auto',
    '2xl': 'h-72 w-auto'
  };

  const variants = {
    default: 'filter-none',
    white: 'brightness-0 invert',
    primary: 'filter-none'
  };

  return (
    <img
      src="/images/LOGO.png"
      alt="EC Cargo"
      className={cn(
        "object-contain transition-all duration-200",
        sizes[size],
        variants[variant],
        className
      )}
      {...props}
    />
  );
};

const LogoPagos = ({ 
  size = 'md',
  className,
  ...props 
}) => {
  const sizes = {
    sm: 'h-8 w-auto',
    md: 'h-12 w-auto',
    lg: 'h-16 w-auto',
    xl: 'h-20 w-auto'
  };

  return (
    <img
      src="/images/PAGOS.png"
      alt="EC Cargo Pagos"
      className={cn(
        "object-contain transition-all duration-200",
        sizes[size],
        className
      )}
      {...props}
    />
  );
};

const LogoPagos2 = ({ 
  size = 'md',
  className,
  ...props 
}) => {
  const sizes = {
    sm: 'h-8 w-auto',
    md: 'h-12 w-auto',
    lg: 'h-16 w-auto',
    xl: 'h-20 w-auto'
  };

  return (
    <img
      src="/images/PAGOS2.png"
      alt="EC Cargo Pagos"
      className={cn(
        "object-contain transition-all duration-200",
        sizes[size],
        className
      )}
      {...props}
    />
  );
};

const LogoIcon = ({ 
  size = 'sm',
  className,
  ...props 
}) => {
  const sizes = {
    xs: 'h-4 w-auto',
    sm: 'h-6 w-auto',
    md: 'h-8 w-auto',
    lg: 'h-10 w-auto'
  };

  return (
    <img
      src="/images/logoi.png"
      alt="EC Cargo"
      className={cn(
        "object-contain transition-all duration-200",
        sizes[size],
        className
      )}
      {...props}
    />
  );
};

Logo.Pagos = LogoPagos;
Logo.Icon = LogoIcon;
Logo.Pagos2 = LogoPagos2;

export default Logo;